import React from 'react';
import { AuthContext } from '@/features/auth-managment/model/auth-context';
import { useAuthLogic } from './hooks/use-auth-logic';

export const AuthProvider = React.forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode;
    visible: boolean;
    onOpen: () => void;
    onClose: () => void;
  }
>(({ children, visible, onOpen, onClose }, ref) => {
  const authContextValue = useAuthLogic({ visible, onOpen, onClose });
  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
});
